import type { Movie } from "@/types/media";

export const movies: Movie[] = [
  {
    id: "m-001",
    title: "星际远征",
    year: 2024,
    country: "美国",
    director: "克里斯·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    genres: ["科幻", "冒险", "剧情"],
    rating: 9.1,
    duration: 148,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20before%20a%20giant%20glowing%20ringed%20planet%2C%20deep%20navy%20and%20black%20gradient%20background%2C%20volumetric%20light%20rays%2C%20dramatic%20moody%20atmosphere%2C%20high%20detail%20editorial%20key%20art&width=600&height=900&seq=movie-poster-001&orientation=portrait",
    description:
      "当地球资源濒临枯竭，一支由顶尖科学家组成的探险队穿越虫洞，前往遥远星系寻找人类新的家园。跨越时间的牺牲与爱，在浩瀚宇宙中编织出一段震撼人心的旅程。",
    updatedAt: "2024-10-12",
  },
  {
    id: "m-002",
    title: "无声之城",
    year: 2023,
    country: "中国大陆",
    director: "陈思远",
    actors: ["张译", "周迅", "王千源"],
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.6,
    duration: 122,
    poster:
      "https://readdy.ai/api/search-image?query=dark%20crime%20thriller%20movie%20poster%2C%20silhouette%20of%20a%20man%20standing%20in%20rainy%20empty%20city%20street%20at%20night%2C%20deep%20blue%20and%20charcoal%20tones%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20mysterious%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-002&orientation=portrait",
    description:
      "一桩离奇的失踪案打破了城市的平静。资深刑警在追查线索的过程中，逐渐发现自己也被卷入了这场无声的博弈之中，真相远比想象中更加复杂。",
    updatedAt: "2024-09-28",
  },
  {
    id: "m-003",
    title: "追光者",
    year: 2024,
    country: "中国大陆",
    director: "李安心",
    actors: ["易烊千玺", "周冬雨", "黄渤"],
    genres: ["剧情", "励志"],
    rating: 8.3,
    duration: 116,
    poster:
      "https://readdy.ai/api/search-image?query=inspirational%20drama%20movie%20poster%2C%20young%20runner%20silhouette%20at%20sunrise%20on%20mountain%20road%2C%20warm%20golden%20light%20against%20dark%20navy%20sky%2C%20hopeful%20cinematic%20tone%2C%20soft%20lens%20flare%2C%20high%20detail%20key%20art&width=600&height=900&seq=movie-poster-003&orientation=portrait",
    description:
      "出身小镇的短跑少年怀揣梦想踏入职业赛场，在一次次跌倒与质疑中，他用脚步丈量热爱的重量，最终跑出属于自己的那道光芒。",
    updatedAt: "2024-10-02",
  },
  {
    id: "m-004",
    title: "深海迷航",
    year: 2022,
    country: "美国",
    director: "詹姆斯·卡梅隆",
    actors: ["汤姆·哈迪", "艾米莉亚·克拉克", "伊德瑞斯·艾尔巴"],
    genres: ["科幻", "惊悚", "冒险"],
    rating: 7.9,
    duration: 134,
    poster:
      "https://readdy.ai/api/search-image?query=underwater%20sci-fi%20horror%20movie%20poster%2C%20submarine%20descending%20into%20abyssal%20trench%20with%20eerie%20blue%20glow%2C%20dark%20teal%20and%20black%20gradient%2C%20bioluminescent%20particles%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=movie-poster-004&orientation=portrait",
    description:
      "一支深海科研队在马里亚纳海沟执行任务时，意外唤醒了沉睡亿万年的未知生物。黑暗的深渊之下，人类最原始的恐惧被彻底释放。",
    updatedAt: "2024-08-15",
  },
  {
    id: "m-005",
    title: "江湖夜雨",
    year: 2021,
    country: "中国大陆",
    director: "徐皓峰",
    actors: ["张震", "倪妮", "王砚辉"],
    genres: ["武侠", "动作", "剧情"],
    rating: 8.1,
    duration: 128,
    poster:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20movie%20poster%2C%20lone%20swordsman%20in%20flowing%20robe%20standing%20on%20misty%20ancient%20rooftop%2C%20deep%20indigo%20night%20with%20falling%20rain%2C%20moonlit%20atmosphere%2C%20ink%20painting%20aesthetic%2C%20high%20detail%20key%20art&width=600&height=900&seq=movie-poster-005&orientation=portrait",
    description:
      "十年前的一场门派血案，让少年习武之人背负起沉重的仇恨。当旧人故剑重逢，江湖恩怨与家国大义交织，他必须在快意恩仇与放下执念之间做出选择。",
    updatedAt: "2024-07-20",
  },
  {
    id: "m-006",
    title: "时间褶皱",
    year: 2024,
    country: "英国",
    director: "丹尼斯·维伦纽瓦",
    actors: ["本尼迪克特·康伯巴奇", "蕾雅·赛杜", "蒂尔达·斯文顿"],
    genres: ["科幻", "剧情", "悬疑"],
    rating: 8.8,
    duration: 141,
    poster:
      "https://readdy.ai/api/search-image?query=philosophical%20sci-fi%20movie%20poster%2C%20fractured%20glass%20corridor%20with%20infinity%20mirror%20reflections%2C%20deep%20blue%20and%20silver%20palette%2C%20surreal%20architectural%20space%2C%20moody%20cinematic%20lighting%2C%20high%20detail&width=600&height=900&seq=movie-poster-006&orientation=portrait",
    description:
      "一位天体物理学家发现时间并非线性流动，而是可以被折叠的褶皱。为了挽回一场意外，她不断穿梭于不同的时间线，却逐渐模糊了记忆与现实的边界。",
    updatedAt: "2024-10-08",
  },
  {
    id: "m-007",
    title: "山那边的家",
    year: 2023,
    country: "中国大陆",
    director: "霍建起",
    actors: ["刘昊然", "咏梅", "张子枫"],
    genres: ["剧情", "家庭"],
    rating: 8.4,
    duration: 118,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20family%20drama%20movie%20poster%2C%20small%20village%20house%20nestled%20in%20misty%20green%20mountains%20at%20dusk%2C%20soft%20warm%20window%20light%2C%20muted%20teal%20and%20amber%20tones%2C%20nostalgic%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-007&orientation=portrait",
    description:
      "在城市打拼多年的年轻人回到故乡，面对日渐苍老的父母与荒芜的村落，他重新理解了家的意义。一段关于告别与和解的温柔旅程。",
    updatedAt: "2024-06-30",
  },
  {
    id: "m-008",
    title: "王牌特工：暗影",
    year: 2024,
    country: "美国",
    director: "马修·沃恩",
    actors: ["塔伦·埃哲顿", "科林·费尔斯", "朱丽安·摩尔"],
    genres: ["动作", "喜剧", "冒险"],
    rating: 7.6,
    duration: 130,
    poster:
      "https://readdy.ai/api/search-image?query=stylish%20spy%20action%20movie%20poster%2C%20elegant%20suited%20agent%20silhouette%20with%20crossed%20gun%20barrels%2C%20deep%20navy%20and%20gold%20accent%20palette%2C%20geometric%20minimal%20composition%2C%20sleek%20cinematic%20design%2C%20high%20detail&width=600&height=900&seq=movie-poster-008&orientation=portrait",
    description:
      "当神秘组织“暗影”在全球掀起危机，特工学院的新生代必须与老牌王牌并肩作战。优雅、幽默与致命一击，一场华丽的情报战就此展开。",
    updatedAt: "2024-09-18",
  },
  {
    id: "m-009",
    title: "长安幻夜",
    year: 2022,
    country: "中国大陆",
    director: "乌尔善",
    actors: ["雷佳音", "倪大红", "辛芷蕾"],
    genres: ["古装", "奇幻", "悬疑"],
    rating: 7.8,
    duration: 138,
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20fantasy%20movie%20poster%2C%20ornate%20tang%20dynasty%20palace%20at%20night%20with%20floating%20lanterns%20and%20mysterious%20fog%2C%20deep%20blue%20and%20crimson%20accents%2C%20epic%20cinematic%20mood%2C%20intricate%20detail%2C%20high%20detail%20key%20art&width=600&height=900&seq=movie-poster-009&orientation=portrait",
    description:
      "盛唐长安，繁华之下暗流涌动。一位负责夜间巡查的武侯接连遭遇离奇命案，抽丝剥茧间揭开了一场关乎王朝命运的惊天阴谋。",
    updatedAt: "2024-05-22",
  },
  {
    id: "m-010",
    title: "雨季告白",
    year: 2023,
    country: "日本",
    director: "新海诚",
    actors: ["神木隆之介", "广濑铃", "松隆子"],
    genres: ["爱情", "剧情", "动画"],
    rating: 8.5,
    duration: 106,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20anime%20movie%20poster%2C%20boy%20and%20girl%20with%20clear%20umbrellas%20under%20rainy%20city%20crossing%2C%20glowing%20blue%20puddles%20and%20warm%20streetlights%2C%20dreamy%20twilight%20palette%2C%20delicate%20cinematic%20illustration%2C%20high%20detail&width=600&height=900&seq=movie-poster-010&orientation=portrait",
    description:
      "在连绵不断的雨季里，少年遇见了能够“听见雨声秘密”的少女。两个孤独的灵魂在细雨中相互靠近，却也明白有些告白注定要留给时间。",
    updatedAt: "2024-04-11",
  },
  {
    id: "m-011",
    title: "极速狂飙",
    year: 2024,
    country: "美国",
    director: "林诣彬",
    actors: ["范·迪塞尔", "杰森·斯坦森", "查理兹·塞隆"],
    genres: ["动作", "赛车", "犯罪"],
    rating: 7.4,
    duration: 136,
    poster:
      "https://readdy.ai/api/search-image?query=high%20octane%20racing%20action%20movie%20poster%2C%20muscle%20car%20drifting%20through%20neon%20night%20city%20with%20motion%20blur%2C%20electric%20blue%20and%20orange%20light%20streaks%2C%20dynamic%20cinematic%20energy%2C%20high%20detail&width=600&height=900&seq=movie-poster-011&orientation=portrait",
    description:
      "一支顶尖改装车队被卷入跨国走私阴谋，为了洗清罪名，他们必须在一场亡命飙车中与时间赛跑。引擎轰鸣，速度即是正义。",
    updatedAt: "2024-09-05",
  },
  {
    id: "m-012",
    title: "雾都疑云",
    year: 2021,
    country: "英国",
    director: "盖·里奇",
    actors: ["汤姆·哈迪", "凯拉·奈特莉", "马克·斯特朗"],
    genres: ["悬疑", "惊悚", "犯罪"],
    rating: 8.0,
    duration: 124,
    poster:
      "https://readdy.ai/api/search-image?query=british%20mystery%20thriller%20movie%20poster%2C%20lone%20detective%20in%20trench%20coat%20walking%20through%20foggy%20london%20alley%20with%20gas%20lamps%2C%20deep%20slate%20blue%20and%20amber%20palette%2C%20atmospheric%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-012&orientation=portrait",
    description:
      "维多利亚时代的伦敦，浓雾笼罩着连绵的谋杀案。一位固执的警探循着蛛丝马迹，发现所有线索都指向了城市上层一个不为人知的秘密社团。",
    updatedAt: "2024-03-19",
  },
  {
    id: "m-013",
    title: "少年游",
    year: 2024,
    country: "中国大陆",
    director: "文牧野",
    actors: ["王俊凯", "张子枫", "王传君"],
    genres: ["青春", "剧情", "成长"],
    rating: 8.2,
    duration: 112,
    poster:
      "https://readdy.ai/api/search-image?query=youth%20coming%20of%20age%20movie%20poster%2C%20group%20of%20teenagers%20cycling%20along%20coastal%20road%20at%20golden%20hour%2C%20nostalgic%20warm%20light%20against%20deep%20blue%20sea%2C%20free%20spirited%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-013&orientation=portrait",
    description:
      "四个即将毕业的高中生决定用一场说走就走的旅行告别青春。在漫长的公路旅程中，他们直面梦想、友情与分离，完成了人生第一次真正的成长。",
    updatedAt: "2024-10-01",
  },
  {
    id: "m-014",
    title: "末日曙光",
    year: 2023,
    country: "美国",
    director: "罗兰·艾默里奇",
    actors: ["约翰·卡拉辛斯基", "艾米莉·布朗特", "渡边谦"],
    genres: ["科幻", "灾难", "动作"],
    rating: 7.2,
    duration: 138,
    poster:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20disaster%20movie%20poster%2C%20ruined%20city%20skyline%20under%20stormy%20sky%20with%20single%20beam%20of%20sunlight%2C%20deep%20blue%20and%20grey%20tones%2C%20dramatic%20epic%20cinematic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=movie-poster-014&orientation=portrait",
    description:
      "当全球电网与通讯在一夜之间瘫痪，一小群幸存者必须穿越废墟寻找传说中的避难所。在文明崩塌的边缘，希望成为人类最后的武器。",
    updatedAt: "2024-02-27",
  },
  {
    id: "m-015",
    title: "老街故事",
    year: 2020,
    country: "中国大陆",
    director: "贾樟柯",
    actors: ["赵涛", "廖凡", "董子健"],
    genres: ["剧情", "文艺"],
    rating: 8.7,
    duration: 110,
    poster:
      "https://readdy.ai/api/search-image?query=arthouse%20drama%20movie%20poster%2C%20quiet%20old%20chinese%20street%20with%20bare%20trees%20and%20small%20shops%20at%20dusk%2C%20muted%20blue%20grey%20and%20warm%20window%20light%2C%20melancholic%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-015&orientation=portrait",
    description:
      "一条即将拆迁的老街上，几户普通人家在时代的洪流中各自坚守。镜头平静地记录下他们的喜怒哀乐，以及那些被时间悄悄带走的东西。",
    updatedAt: "2023-12-08",
  },
  {
    id: "m-016",
    title: "幻影猎人",
    year: 2024,
    country: "韩国",
    director: "朴赞郁",
    actors: ["李政宰", "全智贤", "河正宇"],
    genres: ["动作", "奇幻", "惊悚"],
    rating: 7.7,
    duration: 132,
    poster:
      "https://readdy.ai/api/search-image?query=neo%20noir%20fantasy%20action%20movie%20poster%2C%20hooded%20hunter%20holding%20glowing%20blade%20in%20rainy%20dark%20alley%2C%20deep%20blue%20and%20violet%20accent%20light%2C%20mysterious%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-016&orientation=portrait",
    description:
      "在一座被幻影侵蚀的城市里，猎人们以清除异形为生。当最强大的猎人发现自己也可能早已不再是人类时，猎人与猎物的界限彻底模糊。",
    updatedAt: "2024-09-30",
  },
];